import {PageEnums} from "components/nav/PageEnums";

declare var $:any;

import * as React from 'react';
import { PageWrapper } from 'components/widgets/PageWrapper';
import { searchDataSource } from 'data/SearchDataSource';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';
import { FeedItemContent } from './feed/FeedItem/FeedItemContent';
import { Search } from './widgets/Search';
import {UIState} from "../data/UIState";
import {Transport} from "data/transport";


interface IPageProps {
	nav:any;
}

interface Props extends IPageProps {
	searchText:string;
}

@observer
export class LibraryPage extends React.Component<Props> {
	@observable posts:Array<any> = [];
	@observable searchText:string = '';

	componentDidMount(){
    searchDataSource.addListener(this.handleSearchDataChange);
    this.handleSearchDataChange();
	}
	
  componentWillUnmount() {
    searchDataSource.removeListener(this.handleSearchDataChange);
	}
	
  componentWillReceiveProps(nextProps) {		
  	if(nextProps.searchText!=this.props.searchText){
  		this.handleSearchDataChange();
  	}
	}
	
  handleSearchDataChange = () => {
		this.searchText = searchDataSource.getSearchText();
	}
	
	componentWillMount(){
		// TODO: move this to a datastore
  	$.ajax({
      contentType:"application/json; charset=utf-8",
      dataType:'json',
      headers: { 'Authorization':'Token '+localStorage.getItem('token') },
      type:'GET',
      url: Transport.URL("/library/"+UIState.feedData.solution._id)
    })
    .done((posts)=>{
    	this.posts = posts;
    })
    .fail( (jqXHR, textStatus, errorThrown )=>{
      alert('Library failed to load. This may be due to a network error or lack of Internet. Please try again.');
    });
	}

	@computed
	get filteredPosts() {
		if(this.searchText && this.searchText.length > 0){
			return this.posts.filter((post,i,all) => {
				const postSearchContent = post.title.toLowerCase();
				return postSearchContent.indexOf(this.searchText.toLowerCase()) >= 0;
			});
		} else {
			return this.posts;
		}
	}

	render() {
		return (
			<div>
				{this.props.nav}
				<PageWrapper
					pageEnum={PageEnums.library}
				>
					<Search text="Search" />

					{
						this.searchText?
						<div className="content-title">{this.filteredPosts.length} MATCH{this.filteredPosts.length!=1?"ES":""} FOUND FOR "{this.searchText}"</div>
						:
						<div className="content-title">LATEST FROM LIBRARY</div>
					}

					{
						this.filteredPosts.map((post, idx) => 
							<LibraryPost key={idx}>
								<i style={{fontFamily:'wellness-concepts'}} className={post.icon ? post.icon : "icon-file-o"}></i>
								<FeedItemContent title={post.title} unread={true}>
									<div dangerouslySetInnerHTML={{__html: post.content}}></div>
									{ post.bottomLinkAction && <a className="bottomLinkAction" href={post.bottomLinkAction} target="_blank">{post.bottomLinkTitle}</a>}
								</FeedItemContent>
							</LibraryPost>
						)
					}
				</PageWrapper>
			</div>
			);
		}
}


const dotStyle:any = {
	position: "absolute",
	left: "-20px",
	top: "10px",
	borderRadius: "5px",
	width: "10px",
	height: "10px",
	background: "#F2A60F",
};

const LibraryPost = (props:{children:any}) =>
<div className="post">
	<div className="dot" style={dotStyle}></div>
	<table>
		<tbody>
			<tr>
				<td className="icon">{props.children[0]}</td>
				<td className="mid">{props.children[1]}</td>
				<td className="right">{props.children[2]}</td>
			</tr>
		</tbody>
	</table>
</div>
;

